"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDatasheet = void 0;
const constant_1 = require("../../constant");
exports.addDatasheet = ((datasheetId, datasheetPack) => {
    return {
        type: constant_1.ADD_DATASHEET,
        datasheetId,
        payload: datasheetPack,
    };
});
